import { useLang } from "@/lib/i18n";
import { C, mono } from "@/lib/theme";

const LangToggle = ({ dark = false }) => {
  const { lang, setLang } = useLang();
  const base = { fontFamily: mono, fontSize: 10, letterSpacing: "0.12em", textTransform: "uppercase", padding: "5px 8px", border: "none", background: "transparent", cursor: "pointer", borderRadius: 2 };
  const idle = dark ? "oklch(0.72 0.01 80)" : C.text48;
  const activeBg = C.accent;
  const activeFg = "oklch(0.98 0.006 85)";
  return (
    <div data-testid="lang-toggle" style={{ display: "inline-flex", alignItems: "center", gap: 2, border: `1px solid ${dark ? C.darkLine : C.border}`, borderRadius: 3, padding: 2 }}>
      {["en", "fr"].map((l) => (
        <button
          key={l}
          type="button"
          data-testid={`lang-${l}`}
          aria-pressed={lang === l}
          onClick={() => setLang(l)}
          style={{ ...base, background: lang === l ? activeBg : "transparent", color: lang === l ? activeFg : idle }}
        >
          {l.toUpperCase()}
        </button>
      ))}
    </div>
  );
};

export default LangToggle;
